/* Броячът на банера за бисквитки (20.10.2026, Симеон: „нали ние управляваме банера, трябва да я имаме тая статистика“). Всеки ден - колко пъти
   банерът на Shopify е показан и какво са избрали посетителите. Брои мостът: POST https://br-most.bilkovrai.workers.dev/saglasie?v=<вид>
   (scripts/most-worker.js, saglasieBroi), бройки по ден в D1; статистиката - /saglasie/statistika с ключа на таблото.

   pokazan - банерът чака отговор: API-то за поверителност казва shouldShowBanner() и изборът в currentVisitorConsent() е празен ('' за анализи,
   маркетинг и предпочитания). Двете заедно, защото документацията на Shopify казва за shouldShowBanner() и „не показва дали съгласието вече е
   дадено“, и „true, ако съгласието не е зададено“. Веднъж на сесия (sessionStorage на раздела) - банерът стои на всяка страница до избора.
   priel / otkazal / chastichno - изборът от събитието visitorConsentCollected на document: анализи, маркетинг и предпочитания - всички
   разрешени, всички отказани или друго (saleOfDataAllowed е за САЩ и не влиза). Брои се само отговорът на банера: смяна на вече направен
   избор (през „Предпочитания за бисквитките“) не се брои.

   Какво тръгва: само думата - в адреса и като тяло text/plain. Без адрес на страница, без идентификатор, без бисквитка от нас. sendBeacon,
   защото изборът често е последното нещо преди напускане на страницата; без него - fetch с keepalive и без бисквитки.

   API-то: ако го няма - Shopify.loadFeatures със СЪЩАТА версия като snippets/br-ga4.liquid ('0.1'). Зареждачът на Shopify (load_feature-*.js,
   прочетен 20.10) не тегли втори път скрипт, който вече е на страницата, а друга версия на същото API връща грешка „has already been loaded at
   version“ - затова версията е една и съща. В window.Shopify.customerPrivacy API-то го слага само зареденият consent-tracking-api
   (банерът носи свое копие, но на витрина на Shopify не го излага - storefront-banner.js, прочетен 20.10); ако нашето зареждане не
   отговори, а това на br-ga4 мине, API-то се чете и при DOMContentLoaded и load.

   В редактора на темата (Shopify.designMode) не брои. Пробите с браузър спират адреса в Workbench/vitrina_pazach.py; в сесия с ?br_px_test=1
   пише в конзолата какво праща. */
(function () {
  'use strict';
  var ADRES = 'https://br-most.bilkovrai.workers.dev/saglasie';
  var KLUCH = 'br_biskvitki_pokazan';
  if (!window.Shopify || window.Shopify.designMode) return;

  var pamet = {};
  function cheti(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return pamet[k] || null; } }
  function pishi(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) { pamet[k] = v; } }
  var proba = cheti('br_px_test') === '1';
  function log() { if (proba && window.console) console.info.apply(console, ['[br-biskvitki]'].concat([].slice.call(arguments))); }

  function prati(vid) {
    var url = ADRES + '?v=' + vid;
    log('праща', vid);
    try { if (navigator.sendBeacon && navigator.sendBeacon(url, vid)) return; } catch (e) { /* към резервата */ }
    try {
      window.fetch(url, { method: 'POST', body: vid, keepalive: true, mode: 'no-cors', credentials: 'omit' })
        .catch(function () { /* броячът не пречи на нищо */ });
    } catch (e) { /* без fetch - без бройка */ }
  }
  function pokazan() {
    if (cheti(KLUCH) === '1') return;
    pishi(KLUCH, '1');
    prati('pokazan');
  }

  // chaka: банерът чака ли отговор на тази страница - true, false, или null (API-то още не е прочетено)
  var chaka = null;
  function sasApi(api) {
    if (chaka !== null || !api || typeof api.currentVisitorConsent !== 'function') return;
    var c;
    try { c = api.currentVisitorConsent() || {}; } catch (e) { log('currentVisitorConsent', e); return; }
    var pokazva = false;
    try { pokazva = api.shouldShowBanner() === true; } catch (e) { log('shouldShowBanner', e); }
    chaka = pokazva && !c.analytics && !c.marketing && !c.preferences;
    log('банерът чака отговор:', chaka);
    if (chaka) pokazan();
  }
  function probvai() { sasApi(window.Shopify && window.Shopify.customerPrivacy); }

  // Изборът. Първо стойностите от самото събитие (така ги праща банерът); ако в него няма познати полета - от API-то, както в br-ga4.liquid.
  document.addEventListener('visitorConsentCollected', function (e) {
    if (chaka === false) return;
    var d = (e && e.detail) || {};
    var a = d.analyticsAllowed, m = d.marketingAllowed, p = d.preferencesAllowed;
    if (typeof a !== 'boolean' || typeof m !== 'boolean' || typeof p !== 'boolean') {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      try { a = !!api.analyticsProcessingAllowed(); m = !!api.marketingAllowed(); p = !!api.preferencesProcessingAllowed(); }
      catch (x) { log('изборът не се прочете', x); return; }
    }
    if (chaka === null) pokazan();   // отговорът дойде, преди API-то да е прочетено - значи банерът е бил показан
    chaka = false;
    prati(a && m && p ? 'priel' : !a && !m && !p ? 'otkazal' : 'chastichno');
  });

  var api = window.Shopify.customerPrivacy;
  if (api && typeof api.currentVisitorConsent === 'function') { sasApi(api); return; }
  try {
    if (typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (greshka) {
        if (greshka) log('API-то за поверителност не се зареди', greshka); else probvai();
      });
    }
  } catch (e) { log('loadFeatures', e); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', probvai);
  window.addEventListener('load', probvai);
})();
